<script setup lang="ts">
    import { ref } from 'vue';
    import EchoButton from '../components/EchoButton.vue';
    import MiniAskMeChat from '../components/interactions/MiniAskMeChat.vue';
    import DataTable from '../components/interactions/table/DataTable.vue';
    import PageHeader from '../components/PageHeader.vue';
    import { __ } from '../stores/expressions';
    import InteractionsFilter from '../components/interactions/filter/InteractionsFilter.vue';
    import ScheduleCoaching from '../components/interactions/scheduleCoaching/ScheduleCoaching.vue';
    import { MessageSquareIcon, UsersIcon } from '@lucide/vue';
    import { usePermissions } from '@/js/composables/usePermissions';
    import { AskMeModulePermissionFlag, PermissionArea } from '@/js/consts/permissions';

    const { hasPermission } = usePermissions();
    const canUseMiniAskMe = hasPermission(
        PermissionArea.AskMeModule,
        AskMeModulePermissionFlag.MiniAskMe
    );

    const showAskMeChat = ref(false);
    const toggleAskMeChat = () => {
        showAskMeChat.value = !showAskMeChat.value;
    };

    const closeAskMeChat = () => {
        showAskMeChat.value = false;
    };
</script>
<template>
    <!-- Padding left below the table at the end of the page: page-padding (1.75rem)
         plus InteractionsFilter's pb-7.5 (1.875rem). -->
    <div class="page-padding [--table-fill-space-below:3.625rem]">
        <PageHeader>
            <template #icon><UsersIcon class="size-full" /></template>
            {{ __('interactions-page-title') }}
        </PageHeader>
        <div class="mt-1 relative bg-white rounded-lg shadow-md">
            <InteractionsFilter>
                <template #table>
                    <DataTable />
                </template>
            </InteractionsFilter>
        </div>
    </div>
    <template v-if="canUseMiniAskMe">
        <MiniAskMeChat v-if="showAskMeChat" @close-window="closeAskMeChat" />
        <div
            class="bottom-8 text-gray-dark bg-white fixed z-[202] right-8 shadow-xl/20 heading-md gap-1.5 rounded-[33px]"
        >
            <EchoButton @click="toggleAskMeChat">
                <template #icon-left><MessageSquareIcon /></template>
                {{ __('ask-me') }}
            </EchoButton>
        </div>
    </template>
    <ScheduleCoaching />
</template>
